<template>
  <div class="reason-root">
    <el-dialog
      title="批量审核"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="420px"
      @closed="onClosed"
    >
      <div class="content form-content">
        <div class="big-tip">
          您将对选中的{{ count }}条子任务批量审核，请慎重操作！
        </div>
        <div class="row">
          <div class="tip">审核结果</div>
          <div class="value input fill">
            <el-radio-group v-model="radio">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="row mutlti">
          <div class="tip">驳回原因</div>
          <div class="value input fill">
            <el-input
              type="textarea"
              :rows="4"
              maxlength="250"
              v-model="reason"
            ></el-input>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" type="primary" @click="handleSave"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      reason: "",
      radio: "", //1 通过 2 驳回

      count: 0,
    };
  },

  methods: {
    open(options) {
      this.count = options.count;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    onClosed() {
      this.reset();
    },
    reset() {
      this.reason = "";
      this.count = 0;
      this.radio = "";
    },
    handleSave() {
      if (!this.radio) {
        this.$message.warning("请选择审核结果！");
        return;
      }
      if (this.radio == 2 && !this.reason) {
        this.$message.warning("请填写驳回原因！");
        return;
      }
      this.$emit("onConfirm", { type: this.radio, reason: this.reason });
    },
  },
};
</script>

<style lang="scss" scoped>
.reason-root {
  .form-content {
    .big-tip {
      color: #f5222d;
      margin-bottom: 12px;
    }
    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px 0;
      box-sizing: border-box;

      &.mutlti {
        align-items: flex-start;
      }

      &.contine {
        padding-top: 0;
      }

      &.big {
        .tip {
          height: 32px;
          line-height: 32px;
        }
      }

      .tip {
        width: auto;
        text-align: right;
        font-size: 14px;
        font-weight: 400;
        text-align: right;
        color: #262626;
      }

      .value {
        margin-left: 16px;

        &.input {
          width: 204px;

          ::v-deep .el-date-editor.el-input,
          ::v-deep .el-date-editor.el-input__inner {
            width: 100%;
          }
        }

        &.fill {
          flex: 1;
          width: 0;
        }

        .small-tip {
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #8c8c8c;

          &.warning {
            color: #e6a23c;
          }
        }

        &.mutlti {
          flex: 1;
          width: 0;
          display: flex;

          &.v {
            flex-direction: column;

            .in-row {
              &:not(:first-child) {
                margin-top: 8px;
              }
            }
          }
        }

        .flag-block {
          width: 100%;
          background: #fafafa;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          padding: 8px 16px 16px 16px;
          box-sizing: border-box;
          flex-wrap: wrap;

          .flag-title {
            font-size: 14px;
            font-weight: 400;
            color: #262626;
            margin-right: 8px;
          }

          & > * {
            margin-top: 8px;
          }
        }
      }

      .in-row {
        .value {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
